import React from 'react';
import PropTypes, { func } from 'prop-types';
import { Button } from '@fluentui/react-components';
import { TextEditStyle16Regular } from '@fluentui/react-icons';

export const TextFormattingButton = ({ i18n, onClick }) => (
  <Button
    size="small"
    appearance="transparent"
    className="display-ads-text-formatting-button"
    icon={<TextEditStyle16Regular />}
    onClick={onClick}
  >
    {i18n.getString(_TL_('Text formatting'))}
  </Button>
);

TextFormattingButton.propTypes = {
  i18n: PropTypes.shape({ getString: func }).isRequired,
  onClick: PropTypes.func.isRequired,
};
